import { Grid, Box } from "@material-ui/core";
import React from "react";
import { useAuth } from "../../../../contexts/AuthContext";
import { useCompany } from "../../../../contexts/CompanyContext";
import SupplierTile from "./SupplierTile";

/**
 * @description
 * A component that renders a list of SupplierTiles.
 * Will only render if the user is an admin or if the user is registered for the supplier.
 * Will not render if the supplier is cancelled.
 *
 * @param {object} props - The props object.
 * @param {string} props.url - The url to use for the SupplierTile.
 *
 * @example
 * <SupplierList url="/suppliers" />
 */
export default function SupplierList({ url }) {
  const { currentUser } = useAuth();
  const { activeSuppliers } = useCompany();
  const { suppliers, is_admin } = currentUser;

  const supplierTiles = activeSuppliers
    .filter(supplier => {
      const isActive = is_admin || suppliers?.some(s => s.id === supplier.id);
      return (
        supplier.supplier_status !== 3 &&
        (isActive || supplier.supplier_status === 1)
      );
    })
    .map(supplier => {
      const isActive = is_admin || suppliers?.some(s => s.id === supplier.id);
      return (
        <SupplierTile
          key={supplier.id}
          url={url}
          supplierObject={supplier}
          isActive={isActive}
        />
      );
    });

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <Grid container spacing={2} justifyContent="center">
        {supplierTiles}
      </Grid>
    </Box>
  );
}
